// Paths
export const SHOP_SUBSCRIPTIONS_API_PATH = 'shop/subscriptions';
export const CANCEL_SHOP_SUBSCRIPTION_API_PATH = 'cancel';
export const PAUSE_SHOP_SUBSCRIPTION_API_PATH = 'pause';
export const RESUME_SHOP_SUBSCRIPTION_API_PATH = 'resume';
export const SHOP_SUBSCRIPTIONS_TYPE = 'shop_subscription';
export var ShopSubscriptionInclude;
(function (ShopSubscriptionInclude) {
    ShopSubscriptionInclude["Variant"] = "variant";
    ShopSubscriptionInclude["VariantProduct"] = "variant.product";
    ShopSubscriptionInclude["VariantFrequencies"] = "variant.frequencies";
    ShopSubscriptionInclude["VariantProductTestPanel"] = "variant.product.test_panel";
    ShopSubscriptionInclude["Frequency"] = "frequency";
    ShopSubscriptionInclude["Orders"] = "orders";
    ShopSubscriptionInclude["OrdersLineItems"] = "orders.line_item";
    ShopSubscriptionInclude["OrdersLineItemsVariant"] = "orders.line_items.variant";
    ShopSubscriptionInclude["OrdersLineItemsVariantProduct"] = "orders.line_items.variant.product";
})(ShopSubscriptionInclude || (ShopSubscriptionInclude = {}));
export var ShopSubscriptionFilters;
(function (ShopSubscriptionFilters) {
    ShopSubscriptionFilters["State"] = "state";
    ShopSubscriptionFilters["VariantType"] = "variantType";
})(ShopSubscriptionFilters || (ShopSubscriptionFilters = {}));
//# sourceMappingURL=helpers.js.map